export const COMMERCIAL = 'Commercial/Exchange';
export const MEDICARE = 'Medicare (PART-D)';
export const MEDICAID = 'Medicaid';